import React from 'react';
import './filter.css'
import { supabase } from '../../supabase';
import { useState } from 'react';
import { useEffect } from 'react';

const Filter = (props) => {



    const [category, setcategory]= useState([]);
const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");



useEffect(() => {
    const getCategories = async () => {
      const { data } = await supabase
        .from("category")
        .select("*")
        .order("id", { ascending: true });

      setcategory(data || []);
    };

    getCategories();
  }, []);

  const handleSelect = (item) => {
    setSelected(item.category_name);
    setOpen(false);

  props.onSelect?.(item.category_name);
  };


    return ( 
<div  className="search-wrapper">

          
      
 <div className="filter-input" tabIndex={0} onClick={() => setOpen(!open)}>

        <span className={selected ? "selected-text" : "placeholder"}>
          {selected || props.placeholder}
        </span>

        {props.icon2 && (
          <span className="dropdown-icon">
            <img src={props.icon2} alt="dropdown" />
          </span>
        )}

      </div>





{open && (
  <div className="dropdown-menu">

    <div
      className="dropdown-item"
      onClick={() => {
        setSelected("");         
        setOpen(false);
        props.onSelect?.(null);  
      }}
    >
      All Categories
    </div>

    {category.map((item) => (
      <div
        key={item.id}
        className="dropdown-item"
        onClick={() => handleSelect(item)}
      >
        {item.category_name}
      </div>
    ))}
    
  </div>
)}


</div>


     );
}
 
export default Filter;